@if (!inline) {
  <p-select
    appendTo="body"
    placeholder="Please select property"
    [formControl]="ngControl.control | abstractControlToFormControl"
    [options]="propertyMortgageSelectItems">
    <ng-template let-item pTemplate="selectedItem">
      @if (ngControl.value) {
        <ng-container *ngTemplateOutlet="propertyMortgageItem; context: { $implicit: item }" />
      }
      @if (ngControl.disabled) {
        <shared-icon icon="lock" height="1rem" width="1rem" />
      }
    </ng-template>
    <ng-template let-item pTemplate="item">
      <ng-container *ngTemplateOutlet="propertyMortgageItem; context: { $implicit: item }" />
    </ng-template>
    <ng-template pTemplate="dropdownicon">
      <shared-icon icon="arrow-down" width="0.75rem" />
    </ng-template>
  </p-select>
}

@if (inline) {
  <div #inlinePropertyList class="inline-list">
    @for (option of propertyMortgageSelectItems; track option) {
      <div class="item" [class.selected]="option === ngControl?.value">
        <ng-container *ngTemplateOutlet="propertyMortgageItem; context: { $implicit: option }" />
      </div>
    }
  </div>
  <div class="select-buttons">
    <button
      pButton
      class="p-button p-button-primary icon-only"
      type="button"
      [disabled]="propertyIndex === 0"
      (click)="previousProperty()">
      <shared-icon fill="white" icon="arrow-left" height="0.75rem" width="0.75rem" />
    </button>
    <span>
      <b>{{ propertyIndex + 1 }}</b> / {{ propertyMortgageSelectItems.length }}
    </span>
    <button
      pButton
      class="p-button p-button-primary icon-only"
      type="button"
      [disabled]="propertyIndex === propertyMortgageSelectItems.length - 1"
      (click)="nextProperty()">
      <shared-icon fill="white" icon="arrow-right" height="0.75rem" width="0.75rem" />
    </button>
  </div>
}

<ng-template #propertyMortgageItem let-item>
  <div
    class="property-mortgage-item"
    [class.inline]="inline"
    [class.selected]="item === ngControl.control.value">
    <span class="property-name">{{ item.propertyName }}</span>
    <span class="property-address">{{ item.propertyAddressLines.lines | join: ", " }}</span>
    @if (item.mortgageId) {
      <div class="mortgage">
        <img [src]="item.mortgageLenderLogo" />
        <shared-labeled-value
          label="Outstanding balance"
          [value]="item.mortgageRoundedOutstandingBalance" />
      </div>
    }
  </div>
</ng-template>
